module.exports = __webpack_public_path__ + "img/browser-firefox-logo.c324ad5d.webp";